export default "__VITE_ASSET__3cb52076__"